const fb = require('../../firebaseConfig.js')

export default {
    state: {
		dailyAttendance: []
    },
    getters: {
        dailyAttendance: (state) => {
			return state.dailyAttendance
		}
    },
    mutations: {
        setDailyAttendance(state, val) {
			state.dailyAttendance = val
		},
    },
    actions: {
        async fetchAttendance({commit}, {date}) {
            let attendanceSkeleton = {
                workerId: '',
                permit: false,
                attendanceDate: date,
                checkInTime: 'N/A',
                checkOutTime: 'N/A',
            }
            let dailyAttendance = []
            await fb.workersCollection.get().then(workers => {
                workers.forEach(worker => {
                    let workerEdited = worker.data()
                    workerEdited.id = worker.id
                    fb.attendancesCollection.where('attendanceDate', '==', date).where('workerId', '==', worker.id).get().then(attendances => {
                        if(!attendances.empty) {
                            attendances.docs.forEach(attendance => {
                                workerEdited.attendance = attendance.data()
                                workerEdited.attendance.id = attendance.id
                            })
                        } else {
                            attendanceSkeleton.workerId = worker.id
                            workerEdited.attendance = attendanceSkeleton
                        }
                        dailyAttendance.push(workerEdited)
                    })
                })
                commit('setDailyAttendance', dailyAttendance)
            })
        },
    
        // PENDING FIX updatedOn and createdOn
        createAttendance({getters}, payload) {
            payload.forEach(attendanceRecord => {
                let attendance = {
                    workerId: attendanceRecord.workerId,
                    permit: attendanceRecord.permit,
                    attendanceDate: attendanceRecord.attendanceDate,
                    checkInTime: attendanceRecord.checkInTime,
                    checkOutTime: attendanceRecord.checkOutTime,
                    costCenterId: attendanceRecord.costCenterId
                };
    
                if(attendanceRecord.id) {
                    attendance.updatedOn = fb.fromDate(new Date())
                    attendance.updatedBy = getters.userId
                    fb.attendancesCollection.doc(attendanceRecord.id).update(attendance)
                } else {
                    attendance.createdOn = fb.fromDate(new Date())
                    attendance.createdBy = getters.userId
                    fb.attendancesCollection.add(attendance)
                }
    
            })
        }
    }
}